import { CategoryInspirationResource } from './CategoryInspirationResource';

export class CategoryInspirationListResource {
    errorCode: number;
	errorMessage: string;
    categoryList: CategoryInspirationResource[];
}